import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useSolutionsLetsBuildContent } from '../../../../hooks/useSolutionsLetsBuildContent';
import './LetsBuild.css';

const LetsBuild = () => {
  const { content, isLoading } = useSolutionsLetsBuildContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="lets-build">
      <div className="lets-build__inner">
        <Reveal className="lets-build__content">
          <h2 className="lets-build__title">{title}</h2>
          {text ? <p className="lets-build__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="lets-build__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default LetsBuild;
